import { render, staticRenderFns } from "./CardUpdateInteractiveTags.vue?vue&type=template&id=427a31cc&"
import script from "./CardUpdateInteractiveTags.vue?vue&type=script&lang=js&"
export * from "./CardUpdateInteractiveTags.vue?vue&type=script&lang=js&"
import style0 from "./CardUpdateInteractiveTags.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports